import React, { useState } from "react";
import { useUI } from "../../context/UIContext";
import { createServer, updateServer } from "../../api";

export default function ServerFormModal({ server, isNew, onSaved }) {
  const { toast, closeModal } = useUI();
  const v = server || {};
  const [code, setCode] = useState(v.ServerCode || "");
  const [name, setName] = useState(v.ServerName || "");
  const [ip, setIp] = useState(v.IP || "");
  
  const msToSec = (ms, def) => (ms ? ms / 1000 : def);
  const [cpu, setCpu] = useState(msToSec(v.TimerScanCPU, 3));
  const [ram, setRam] = useState(msToSec(v.TimerScanRAM, 3));
  const [net, setNet] = useState(msToSec(v.TimerScanNetwork, 3));
  const [hdd, setHdd] = useState(msToSec(v.TimeScanHDD ?? v.TimerScanHDD, 10));
  const [app, setApp] = useState(msToSec(v.TimeScanApp ?? v.TimerScanApp, 5));

  const save = async () => {
    const codeUp = code.trim().toUpperCase();
    const ipT = ip.trim();
    if (isNew && !codeUp) return toast("Nhập ServerCode", "err");
    if (!ipT) return toast("Nhập IP Address", "err");

    const secToMs = (s, def) => Math.round((parseFloat(s) || def) * 1000);
    const body = {
      ServerName: name.trim() || codeUp,
      IP: ipT,
    };
    
    if (isNew) {
      body.ServerCode = codeUp;
      body.TimerScanCPU = secToMs(cpu, 3);
      body.TimerScanRAM = secToMs(ram, 3);
      body.TimerScanNetwork = secToMs(net, 3);
      body.TimerScanHDD = secToMs(hdd, 10);
      body.TimerScanApp = secToMs(app, 5);
    }

    try {
      const { ok, data } = isNew
        ? await createServer(body)
        : await updateServer(v.ServerCode, body);
      if (!ok) return toast(data.message || "Lỗi server", "err");
      closeModal();
      toast(
        isNew ? `Đã thêm ${body.ServerCode}` : `Đã cập nhật ${v.ServerCode}`,
        "ok"
      );
      onSaved(
        isNew
          ? { ...body, IsOnline: 0, isConnected: false, metrics: {}, apps: [] }
          : { ...v, ...body }
      );
    } catch (err) {
      toast("Không kết nối được BackendNode", "err");
    }
  };


  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }} onKeyDown={(e) => e.key === "Enter" && save()}>
      <div style={{ fontSize: "12px", fontWeight: 600, color: "var(--dim)", marginBottom: "7px" }}>
        Server code {isNew ? "*" : "· locked"}
      </div>
      <input
        className="field-inp"
        type="text"
        value={code}
        disabled={!isNew}
        placeholder="SV-07"
        onChange={(e) => setCode(e.target.value.toUpperCase())}
        style={!isNew ? { background: "var(--bg)", color: "var(--faint)" } : {}}
      />

      <div style={{ fontSize: "12px", fontWeight: 600, color: "var(--dim)", margin: "14px 0 7px" }}>Display name</div>
      <input
        className="field-inp"
        type="text"
        value={name}
        placeholder="Web Server 07"
        onChange={(e) => setName(e.target.value)}
      />

      <div style={{ fontSize: "12px", fontWeight: 600, color: "var(--dim)", margin: "14px 0 7px" }}>IP address *</div>
      <input
        className="field-inp"
        type="text"
        value={ip}
        placeholder="10.0.0.17"
        onChange={(e) => setIp(e.target.value)}
        style={{ fontFamily: "var(--font-mono)" }}
      />

      {isNew && (
        <>
          <div style={{ fontSize: "12px", fontWeight: 600, color: "var(--dim)", margin: "14px 0 7px" }}>
            Scan interval (seconds)
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "8px", marginBottom: "10px" }}>
            <div>
              <div style={{ fontSize: "11px", color: "var(--faint)", marginBottom: "4px" }}>CPU</div>
              <input
                className="field-inp"
                value={cpu}
                onChange={(e) => setCpu(e.target.value)}
                style={{ height: "36px", padding: "0 10px", margin: 0, fontFamily: "var(--font-mono)", fontSize: "13px" }}
              />
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "var(--faint)", marginBottom: "4px" }}>RAM</div>
              <input
                className="field-inp"
                value={ram}
                onChange={(e) => setRam(e.target.value)}
                style={{ height: "36px", padding: "0 10px", margin: 0, fontFamily: "var(--font-mono)", fontSize: "13px" }}
              />
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "var(--faint)", marginBottom: "4px" }}>Network</div>
              <input
                className="field-inp"
                value={net}
                onChange={(e) => setNet(e.target.value)}
                style={{ height: "36px", padding: "0 10px", margin: 0, fontFamily: "var(--font-mono)", fontSize: "13px" }}
              />
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "var(--faint)", marginBottom: "4px" }}>HDD</div>
              <input
                className="field-inp"
                value={hdd}
                onChange={(e) => setHdd(e.target.value)}
                style={{ height: "36px", padding: "0 10px", margin: 0, fontFamily: "var(--font-mono)", fontSize: "13px" }}
              />
            </div>
            <div>
              <div style={{ fontSize: "11px", color: "var(--faint)", marginBottom: "4px" }}>App</div>
              <input
                className="field-inp"
                value={app}
                onChange={(e) => setApp(e.target.value)}
                style={{ height: "36px", padding: "0 10px", margin: 0, fontFamily: "var(--font-mono)", fontSize: "13px" }}
              />
            </div>
          </div>
        </>
      )}

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "22px" }}>
        <button
          onClick={closeModal}
          style={{
            padding: "0 16px",
            height: "40px",
            borderRadius: "10px",
            background: "transparent",
            border: "1px solid var(--border2)",
            color: "var(--dim)",
            fontSize: "13px",
            fontWeight: 600,
            cursor: "pointer",
            transition: "all 0.15s ease",
          }}
          className="form-cancel-btn"
        >
          Cancel
        </button>
        <button
          onClick={save}
          style={{
            padding: "0 18px",
            height: "40px",
            borderRadius: "10px",
            background: "var(--primary)",
            border: "none",
            color: "#fff",
            fontSize: "13px",
            fontWeight: 700,
            cursor: "pointer",
            transition: "all 0.15s ease",
          }}
          className="form-submit-btn"
        >
          {isNew ? "Add server" : "Save changes"}
        </button>
      </div>
      
      <style>{`
        .form-cancel-btn:hover {
          color: var(--text) !important;
        }
        .form-submit-btn:hover {
          filter: brightness(1.07);
        }
      `}</style>
    </div>
  );
}
